import { render, staticRenderFns } from "./info-box.vue?vue&type=template&id=3c8ffc60&scoped=true&"
import script from "./info-box.vue?vue&type=script&lang=js&"
export * from "./info-box.vue?vue&type=script&lang=js&"
import style0 from "./info-box.vue?vue&type=style&index=0&id=3c8ffc60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8ffc60",
  null
  
)

export default component.exports